import { LinkButton } from '@cian/ui-kit/button';
import { Responsive } from '@cian/ui-kit/responsive';
import * as React from 'react';

import * as styles from './UserRelated.css';
import { LoginButton } from '../LoginButton';

interface IUserRelatedProps {
  gptButton: JSX.Element | null;
  userMenu: JSX.Element | null;
  utilities: JSX.Element;
  specialPromo: JSX.Element | null;
  placeOfferLink: string | null;
  hasBlockedSanction: boolean;
  shouldShowNewPlacementText: boolean;
  onPlaceOfferClick(): void;
  onAuthenticateClick(): void;
}

export const UserRelated: React.FC<IUserRelatedProps> = ({
  gptButton,
  userMenu,
  utilities,
  placeOfferLink,
  hasBlockedSanction,
  specialPromo,
  shouldShowNewPlacementText,
  onPlaceOfferClick,
  onAuthenticateClick,
}) => {
  return (
    <div className={styles['container']}>
      <Responsive tablet desktop>
        {specialPromo && <div className={styles['special-promos']}>{specialPromo}</div>}
      </Responsive>
      <Responsive desktop>{gptButton && <div className={styles['gpt-button']}>{gptButton}</div>}</Responsive>
      <div className={styles['utilities']}>{utilities}</div>
      <Responsive tablet desktop>
        {placeOfferLink && !hasBlockedSanction && (
          <div className={styles['place']}>
            <LinkButton
              href={placeOfferLink}
              size="XS"
              onClick={onPlaceOfferClick}
              data-testid="header-add-offer-buttons"
            >
              + {shouldShowNewPlacementText ? 'Разместить за 0 ₽' : 'Разместить объявление'}
            </LinkButton>
          </div>
        )}
        {userMenu || <LoginButton onAuthenticateClick={onAuthenticateClick} />}
      </Responsive>
    </div>
  );
};
